import { DocumentNode, OperationVariables, SkipToken, useSuspenseQuery } from '@apollo/client';
import { ReactNode, useEffect } from 'react';
import { ErrorModal } from '../ErrorModal/ErrorModal';

type Props<D, V> = {
    query: DocumentNode;
    variables: {
        variables: V;
    } | SkipToken;
    onResult?: (data?: D) => void;
    children: ({ data }: {data?: D}) => ReactNode;
}

export function Query<D, V extends OperationVariables>(
    { query, variables, onResult, children }: Props<D, V>,
) {
    const { data, error } = useSuspenseQuery<D, V>(query, variables);

    useEffect(() => {
        if (onResult) {
            onResult(data);
        }
    }, [data, onResult]);

    if (error) {
        return <ErrorModal/>;
    }

    return children({ data });
}
